import { userType } from "../../DTO";
import { Api } from "../api";

export const ChatGPT = (user: userType, message: string) => {
    return new Promise<{ reply: string }>(async (resolve, reject) => {
        const api = new Api({
            method: "post",
            path: "chat/ai-reply",
            header: {
                Authorization: "Bearer " + user?.access_token,
            },
            body: { message },
        });
        api.call()
            .then((data: any) => {
                const reply = data?.data?.reply ?? "";
                resolve({ reply });
            })
            .catch((err: any) => {
                const msg =
                    err?.response?.data?.message ||
                    err?.message ||
                    "An unexpected error occurred while contacting D2Type AI.";
                reject({ message: msg });
            });
    });
};
